import { PERMISSION_CODES, permissionsForModule, } from './permissions.js';
/**
 * Perfis de acesso padrão criados para cada tenant.
 * O perfil `admin` sempre possui todas as permissões e não pode ser editado.
 */
export const SYSTEM_ROLE_CODES = [
    'admin',
    'manager',
    'financial',
    'hr',
    'production',
    'stock',
    'purchasing',
    'sales',
    'maintenance',
    'logistics',
    'viewer',
];
const modules = (...mods) => mods.flatMap((m) => [...permissionsForModule(m)]);
const readOnly = (...mods) => mods.map((m) => `${m}:read`);
const unique = (codes) => [...new Set(codes)];
export const SYSTEM_ROLE_TEMPLATES = [
    {
        code: 'admin',
        name: 'Administrador da empresa',
        description: 'Acesso total a todos os módulos e configurações da empresa.',
        permissions: [...PERMISSION_CODES],
    },
    {
        code: 'manager',
        name: 'Gerente',
        description: 'Acesso amplo aos módulos operacionais, com aprovações, sem gerenciar usuários.',
        permissions: unique([
            ...PERMISSION_CODES.filter((c) => !c.startsWith('users:') && !c.startsWith('roles:') && c !== 'settings:manage'),
        ]),
    },
    {
        code: 'financial',
        name: 'Financeiro',
        description: 'Gestão financeira, notas fiscais e consulta a vendas e compras.',
        permissions: unique([
            ...modules('financial', 'invoices', 'machines'),
            ...readOnly('dashboard', 'customers', 'suppliers', 'sales', 'purchases', 'reports', 'documents', 'logistics'),
            'reports:export',
            'documents:create',
        ]),
    },
    {
        code: 'hr',
        name: 'RH',
        description: 'Gestão de colaboradores, incluindo dados sensíveis.',
        permissions: unique([
            ...modules('hr', 'hr_sensitive'),
            ...readOnly('dashboard', 'documents'),
            'documents:create',
        ]),
    },
    {
        code: 'production',
        name: 'Produção',
        description: 'Ordens de produção, apontamentos e qualidade.',
        permissions: unique([
            ...modules('production', 'quality', 'waste'),
            ...readOnly('dashboard', 'products', 'materials', 'stock', 'sales'),
            'stock:create',
        ]),
    },
    {
        code: 'stock',
        name: 'Estoque',
        description: 'Materiais, movimentações e inventário.',
        permissions: unique([
            ...modules('stock', 'materials'),
            ...readOnly('dashboard', 'products', 'production', 'purchases', 'suppliers', 'waste'),
        ]),
    },
    {
        code: 'purchasing',
        name: 'Compras',
        description: 'Pedidos de compra e fornecedores.',
        permissions: unique([
            ...modules('purchases', 'suppliers'),
            ...readOnly('dashboard', 'materials', 'stock', 'invoices', 'financial'),
        ]),
    },
    {
        code: 'sales',
        name: 'Vendas',
        description: 'Orçamentos, pedidos de venda e clientes.',
        permissions: unique([
            ...modules('sales', 'customers', 'logistics'),
            ...readOnly('dashboard', 'products', 'stock', 'production', 'documents', 'invoices'),
            'stock:create',
            'documents:create',
        ]),
    },
    {
        code: 'maintenance',
        name: 'Manutenção',
        description: 'Patrimônio, equipamentos e ordens de manutenção.',
        permissions: unique([
            ...modules('maintenance', 'assets', 'machines'),
            ...readOnly('dashboard', 'stock', 'documents'),
            'documents:create',
            'stock:create',
        ]),
    },
    {
        code: 'logistics',
        name: 'Expedição',
        description: 'Separação, romaneios e entregas.',
        permissions: unique([
            ...modules('logistics', 'waste'),
            ...readOnly('dashboard', 'sales', 'customers', 'products', 'stock', 'assets', 'hr'),
            'stock:create',
            'documents:read',
            'documents:create',
        ]),
    },
    {
        code: 'viewer',
        name: 'Visualizador',
        description: 'Somente leitura nos módulos operacionais, sem dados sensíveis de RH.',
        permissions: unique([
            ...PERMISSION_CODES.filter((c) => c.endsWith(':read') &&
                !c.startsWith('hr_sensitive:') &&
                !c.startsWith('users:') &&
                !c.startsWith('roles:') &&
                !c.startsWith('audit:')),
        ]),
    },
];
export function isSystemRoleCode(value) {
    return SYSTEM_ROLE_CODES.includes(value);
}
//# sourceMappingURL=roles.js.map